import Config from 'react-native-config';

import { RootState, RootDispatch } from 'store/types';

import { KEY } from '../types';
import { languagesDataSelector } from './selectors';
import { PROVIDER_SEARCH_CLIENT } from '../constants';

export const PROVIDER_LANGUAGES = `${KEY}.PROVIDER_LANGUAGES`;
export const PROVIDER_LANGUAGES_FAIL = `${KEY}.PROVIDER_LANGUAGES_FAIL`;
export const PROVIDER_LANGUAGES_SUCCESS = `${KEY}.PROVIDER_LANGUAGES_SUCCESS`;

export const providerLanguages = () => (dispatch: RootDispatch, getState: () => RootState) => {
  if (languagesDataSelector(getState()).length) return;

  dispatch({
    type: PROVIDER_LANGUAGES,
    payload: {
      client: PROVIDER_SEARCH_CLIENT,
      request: {
        method: 'get',
        url: Config.PROVIDER_URL_PROVIDER_GET_LANGUAGES
      }
    }
  });
};
